var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.can([ _vm.permissions.company.employees.updateEmail ], false, _vm.entry))?_c('v-btn',{staticClass:"mt-3 ml-4",attrs:{"icon":""},on:{"click":_vm.openDialog}},[_c('v-icon',[_vm._v("mdi-pencil")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }